// extracted by mini-css-extract-plugin
export var autoExpand = "_2x-8";
export var container = "_2x-7";
export var containerWidth = "_2x-5";
export var disabled = "_2x-2";
export var error = "_2x-3";
export var fullWidth = "_2x-6";
export var inputWrapper = "_2x-0";
export var small = "_2x-1";
export var textarea = "_2x-4";